import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { FormService } from '../../../common/services/form.service';
import { Field } from 'src/sb-tools/typescript/models/field.model';
import { ClientField } from '../../../common/models/client-field.model';
import { NgClass } from '@angular/common';
import { FormFieldLabelComponent } from '@form-field-module/common/components/form-field-label/form-field-label.component';

@Component({
    selector: 'sb-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    imports: [NgClass, FormsModule, FormFieldLabelComponent],
})
export class CheckboxComponent implements OnInit {
    @Input() formField: Field | ClientField;

    isChecked: boolean;

    constructor(public formService: FormService) {}

    ngOnInit(): void {
        if (this.formField.value) {
            this.isChecked = this.formField.value.toLowerCase() === 'true';
            this.onChange();
        }
    }

    onChange(): void {
        this.formField.value = this.isChecked.toString();
    }
}
